var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('swiper',{ref:"mySwiper",staticClass:"sliders",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.offers),function(offer){return _c('swiper-slide',{key:offer.id,nativeOn:{"click":function($event){return _vm.OfferData(offer)}}},[_c('OfferSingleTile',{attrs:{"offer":offer}})],1)}),1),_c('store-picker')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }